"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribeMarketInformation = subscribeMarketInformation;
const AAPITypes_1 = require("../AAPITypes");
function subscribeMarketInformation(params) {
    const correlationData = this.addToCorrelation(params);
    if (this.initializationParams.useJSON) {
        const request = {
            aapiId: AAPITypes_1.aapiId.subscribeMarketInformation,
        };
        this.sendSubscriptionMessageJSON(request);
    }
    else {
        const request = { 0: correlationData.correlationDataId };
        request[7] = params.fetchOnly;
        if (params.wantSelectionInformation !== undefined) {
            request[8] = params.wantSelectionInformation;
        }
        if (params.wantExchangeLangugeInformationOnly !== undefined) {
            request[9] = params.wantExchangeLangugeInformationOnly;
        }
        if (params.marketTaggedValueTopicNames !== undefined) {
            request[10] = params.marketTaggedValueTopicNames;
        }
        //if (params.eventClassifierId !== undefined) {
        //  request[2] = '' + params.eventClassifierId;
        //  request[5] = true;
        //}
        if (params.marketIds !== undefined) {
            request[6] = params.marketIds.join('~');
        }
        request[12] =
            params.wantSelectionBlurb !== undefined
                ? params.wantSelectionBlurb
                : false;
        if (params.bettingTypeId !== undefined) {
            request[13] = params.bettingTypeId;
        }
        this._sendStreamingMessage(AAPITypes_1.aapiId.subscribeMarketInformation, request);
    }
    return correlationData.promise;
}
